import script from "./dataBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./dataBlock.vue?vue&type=script&setup=true&lang=js"

import "./dataBlock.vue?vue&type=style&index=0&id=02983698&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/h-waterwork-storeroom-webui_prev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02983698"]])

export default __exports__